import { h, ListView } from "harmaja"
import * as L from "lonna"
import { Board } from "../../../common/src/domain"
import { BoardFocus, getSelectedItems } from "./board-focus"
import { boundingRect } from "./boardContentArea"

const PAD = 0.6 // rem, a bit outside the per-item selection border

// A subtle bounding box around each group that has selected members (Miro-style),
// and a lighter one around the group under the mouse.
export const GroupOutlines = ({
    board,
    focus,
    boardElement,
}: {
    board: L.Property<Board>
    focus: L.Property<BoardFocus>
    boardElement: L.Property<HTMLElement | null>
}) => {
    // hovered item id via event delegation on the board element
    const hoveredId = L.atom<string | null>(null)
    boardElement.forEach((el) => {
        if (!el) return
        el.addEventListener("mouseover", (e) => {
            const itemEl = (e.target as HTMLElement).closest?.("[data-itemid]") as HTMLElement | null
            hoveredId.set(itemEl ? itemEl.getAttribute("data-itemid") : null)
        })
        el.addEventListener("mouseleave", () => hoveredId.set(null))
    })

    const groups = L.view(board, focus, hoveredId, (b, f, hovered) => {
        const selected = getSelectedItems(b)(f)
        const selectedGroups = new Set(selected.map((i) => i.groupId).filter((g): g is string => !!g))
        const hoveredGroup = hovered ? b.items[hovered]?.groupId : null
        const all = new Set(selectedGroups)
        if (hoveredGroup) all.add(hoveredGroup)
        return [...all].map((groupId) => {
            const members = Object.values(b.items).filter((i) => i.groupId === groupId && !i.hidden)
            return { groupId, rect: boundingRect(members), hover: !selectedGroups.has(groupId) }
        })
    })
    return (
        <ListView
            observable={groups}
            renderObservable={(groupId, g) => (
                <span
                    className={L.view(g, (x) => (x.hover ? "group-outline hover" : "group-outline"))}
                    style={L.view(g, ({ rect }) => ({
                        top: `-${PAD}rem`,
                        left: `-${PAD}rem`,
                        width: `calc(${rect.width}em + 2 * ${PAD}rem)`,
                        height: `calc(${rect.height}em + 2 * ${PAD}rem)`,
                        transform: `translate(${rect.x}em, ${rect.y}em)`,
                    }))}
                />
            )}
            getKey={(g) => g.groupId}
        />
    )
}
